import React from "react";

const StarIcon = ({ filled, half, starSize = 4 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={`w-${starSize} h-${starSize} ${filled ? 'text-yellow-400' : 'text-gray-300'}`}
    viewBox="0 0 24 24"
    fill={filled || half ? 'currentColor' : 'none'}
    stroke="currentColor"
  >
    {half ? (
      <>
        <defs>
          <linearGradient id="halfStar" x1="0" x2="1" y1="0" y2="0">
            <stop offset="50%" stopColor="currentColor" />
            <stop offset="50%" stopColor="transparent" />
          </linearGradient>
        </defs>
        <path
          fill="url(#halfStar)"
          d="M12 .587l3.668 7.431 8.2 1.193-5.934 5.785 1.4 8.164L12 18.896l-7.334 3.864 1.4-8.164L.132 9.211l8.2-1.193L12 .587z"
        />
      </>
    ) : (
      <path
        d="M12 .587l3.668 7.431 8.2 1.193-5.934 5.785 1.4 8.164L12 18.896l-7.334 3.864 1.4-8.164L.132 9.211l8.2-1.193L12 .587z"
      />
    )}
  </svg>
);

export default function TwRating(props) {
  const { className = "", ratingNumber = 5, rating = 0, starSize = 4 } = props
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 >= 0.5;
  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
  // console.log("ratingNumber", ratingNumber);
  // console.log("rating", Array.isArray(rating) ? (rating.length ? rating[0] : 0) : rating || 0);

  return (
    <div className="flex items-center gap-2">
      <div className="flex items-center space-x-1">
        {[...Array(fullStars)].map((_, i) => (
          <StarIcon key={`full-${i}`} filled starSize={starSize} />
        ))}
        {hasHalfStar && <StarIcon half starSize={starSize} />}
        {[...Array(emptyStars)].map((_, i) => (
          <StarIcon key={`empty-${i}`} starSize={starSize} />
        ))}
      </div>
      {/* <div className="mr-1 flex items-center">
        {[...Array.from({ length: ratingNumber }, (_, index) => index)].map((r) => (
          <StarIcon
            key={r}
            aria-hidden="true"
            className={classNames(
              (Array.isArray(rating) ? (rating.length ? rating[0] : 0) : rating || 0) > r ? 'text-yellow-400' : 'text-gray-200',
              'size-5 shrink-0',
            )}
          />
        ))}
      </div> */}
      <p className="text-sm text-gray-700">
        {Array.isArray(rating) ? (rating.length ? rating[0] : 0) : rating || 0}
        <span className="sr-only"> out of 5 stars</span>
      </p>
      <div aria-hidden="true" className="ml-4 text-sm text-gray-300">
        ·
      </div>
    </div>
  );
}
